import { collection, getDocs } from 'firebase/firestore';
import { ref, listAll, getDownloadURL } from 'firebase/storage';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, storage } from '../FirebaseConfig';
import { IoSearch } from 'react-icons/io5';
import { FaSearch } from 'react-icons/fa';

const SearchBar = () => {
    const [searchInput, setSearchInput] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const [newsList, setNewsList] = useState([]);
    const [contentList, setContentList] = useState([]);
    const [pdfs, setPdfs] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const newsCollection = collection(db, 'freelancer');
                const newsSnapshot = await getDocs(newsCollection);
                const newsList = newsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setNewsList(newsList);
                setLoading(false);
            } catch (error) {
                console.error(`Failed to fetch news: ${error.message}`);
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const contentCollection = collection(db, 'mentors');
                const contentSnapshot = await getDocs(contentCollection);
                const contentList = contentSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setContentList(contentList);
                setLoading(false);
            } catch (error) {
                console.error(`Failed to fetch content: ${error.message}`);
                setLoading(false);
            }
        };

        fetchContent();
    }, []);

    // useEffect(() => {
    //     const fetchPDFs = async () => {
    //         try {
    //             const pdfRef = ref(storage, 'pdfs/');
    //             const res = await listAll(pdfRef);

    //             const pdfUrls = await Promise.all(
    //                 res.items.map(async (itemRef) => {
    //                     const url = await getDownloadURL(itemRef);
    //                     return { name: itemRef.name, url };
    //                 })
    //             );

    //             setPdfs(pdfUrls);
    //         } catch (error) {
    //             console.error('Error fetching PDFs:', error);
    //         }
    //     };

    //     fetchPDFs();
    // }, []);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchInput(value);
        if (value) {
            filterSearchResults(value);
        } else {
            setSearchResults([]);
            setDropdownVisible(false);
        }
    };

    const filterSearchResults = (query) => {
        const combinedList = [
            ...newsList.map(item => ({ ...item, type: 'freelancer' })),
            ...contentList.map(item => ({ ...item, type: 'mentors' })),
            // ...pdfs.map(item => ({ ...item, type: 'pdf' }))
        ];
        const filteredResults = combinedList.filter(item => {
            if (item.coursename && typeof item.coursename === 'string') {
                return item.coursename.toLowerCase().includes(query.toLowerCase());
            }
            if (item.expertise && typeof item.expertise === 'string') {
                return item.expertise.toLowerCase().includes(query.toLowerCase());
            }
            if (item.about && typeof item.about === 'string') {
                return item.about.toLowerCase().includes(query.toLowerCase());
            }
            if (item.name && typeof item.name === 'string') {
                return item.name.toLowerCase().includes(query.toLowerCase());
            }
            return false;
        });
        setSearchResults(filteredResults);
        setDropdownVisible(true);
    };

    const handleResultClick = (result) => {
        if (result.type === 'freelancer') {
            navigate(`/tech-talent-program`);
            // } else if (result.type === 'pdf') {
            //     navigate(`/transfer-posting`);
        } else if (result.type === 'mentors') {
            navigate(`/mentor/${result.id}`);
        }
        setSearchInput('');
        setSearchResults([]);
        setDropdownVisible(false);
    };

    return (
        <div className='w-auto'>
            <div className='lg:w-[70%] flex w-[100%]'>
                <input
                    type="text"
                    value={searchInput}
                    onChange={handleInputChange}
                    onFocus={() => setDropdownVisible(true)}
                    placeholder="Search..."
                    onBlur={() => setTimeout(() => setDropdownVisible(false), 200)}
                    className=" flex-grow p-2 lg:w-auto  w-full rounded-l-full border-t-2 border-b-2 border-l-2 focus:outline-none "
                    disabled={loading}
                />
                <button className="border-r-2 pr-2 bg-white border-t-2 border-b-2 rounded-r-full text-gray-500 hover:text-blue-500">
                    <FaSearch size={20}/>
                </button>
                {/* <input
                    type="text"
                    placeholder=""
                    value={searchInput}
                    onChange={handleInputChange}
                    onFocus={() => setDropdownVisible(true)}
                    onBlur={() => setTimeout(() => setDropdownVisible(false), 200)}
                    className=''
                    disabled={loading}
                /> */}
            </div>
            <div className='absolute'>
                {isDropdownVisible && searchResults.length > 0 && (
                    <div className='absolute top- cursor-pointer mt-2 md:w-60 bg-white border border-gray-300 rounded-md shadow-lg z-10 dropdown-container'>
                        {searchResults.map((result) => (
                            <div
                                key={result.id || result.name}  // Unique key for PDFs and others
                                onClick={() => handleResultClick(result)}
                                className='search-result-item hover:bg-slate-200 p-2'
                            >
                                {result.heading || result.name || result.about || result.expertise || result.coursename}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchBar;
